import { useEffect } from 'react';

import { useAppDispatch } from '../store/hooks';
import { checkForUpdates } from '../features/table/table.actions';

// Re-checks the data ETag when the tab regains focus after >10 min of inactivity.
export function useDataFreshness() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const minTimeBeforeRequest = 10 * 60_000;
    let inactivityTime = 0;

    function visibilityChangeHandler() {
      if (document.hidden) {
        inactivityTime = Date.now();
      } else {
        const currentTime = Date.now();
        const timeSinceLastVisit = currentTime - inactivityTime;

        if (timeSinceLastVisit >= minTimeBeforeRequest) {
          inactivityTime = currentTime;
          void dispatch(checkForUpdates());
        }
      }
    }

    document.addEventListener('visibilitychange', visibilityChangeHandler);
    return () => {
      document.removeEventListener('visibilitychange', visibilityChangeHandler);
    };
  }, [dispatch]);
}
